import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult } from '../../rules';
import IsPropertyTenantWillingToBeCommercialGuarantor from '../../rules/IsPropertyTenantWillingToBeCommercialGuarantor';
import IsWillingToProvideCommercialGuarantor from '../../rules/IsWillingToProvideCommercialGuarantor';

class CommercialGuarantorLegalNameRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isWillingToProvideCommercialGuarantor =
      IsWillingToProvideCommercialGuarantor.evaluate(data);
    const isPropertyTenantWillingToBeCommercialGuarantor =
      IsPropertyTenantWillingToBeCommercialGuarantor.evaluate(data);

    return isWillingToProvideCommercialGuarantor ||
      isPropertyTenantWillingToBeCommercialGuarantor
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new CommercialGuarantorLegalNameRuleset();
